import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ReactDOM from 'react-dom';
import { initDatadog, initSentry } from './monitoring';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';
import './styles/placement.css';
import './styles/portal.css';
import './styles/user_management.css';
import { TheXOLVSuperPortal } from './TheXOLVSuperPortal';


// see comment inside init function for why this promise is needed
const datadogInitializedPromise = initDatadog();

initSentry();

datadogInitializedPromise.then(() => {
    ReactDOM.render(
        <React.StrictMode>
            <TheXOLVSuperPortal/>
        </React.StrictMode>,
        document.getElementById('root')
    );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
